var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"ma-4 pa-0 deleteBtn",attrs:{"color":"error","width":"'10px'","height":"'12px'","icon":""},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.handleRemoveClick()}}},[_c('v-icon',{staticClass:"pa-0",attrs:{"color":"#EF8686"}},[_vm._v("mdi-delete")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }